import React, { createContext, useContext, ReactNode } from 'react'
import { ThemeProvider, CssBaseline } from '@mui/material'
import { lightTheme } from '../theme/theme'

interface ThemeContextType {
  toggleDarkMode: () => void
  isDarkMode: boolean
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined)

export const useThemeMode = () => {
  const ctx = useContext(ThemeContext)
  if (!ctx) throw new Error('useThemeMode must be used within ThemeModeProvider')
  return ctx
}

const ThemeModeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <ThemeContext.Provider value={{ toggleDarkMode: () => {}, isDarkMode: false }}>
      <ThemeProvider theme={lightTheme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  )
}

export default ThemeModeProvider
